import Layout from '../../layout/default';
import { useEffect, useState, useRef , useContext} from "react";
import { Link, Route, Routes} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { MediaGroup, Media, MediaText, Image, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating, Timeline } from "../../components";
import Spinner from 'react-bootstrap/Spinner';
import { Breadcrumb } from 'react-bootstrap';
import { Modal, Row, Col, Form, Card} from 'react-bootstrap'
import { Block } from '../../components';
import { AppContext } from "../../context/AppContext"
import CreatePaymentMethod from '../Payment/CreatePaymentMethod';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import PaymentMethodsList from '../Payment/PaymentMethodsList';
import { useApiClient } from '../../ApiService/useApiClient';

const baseURL = "HMCareData/customer/subscription";
//const stripePromise = loadStripe('pk_test_0uHCGUr6JenaMCwndZsk1KD5'); // Your Stripe public key
const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY); // Your Stripe public key


function Subscription() {

    const api = useApiClient();

    const { user , token} = useContext(AppContext);
    const[data, setdata] = useState(null);  
    const[error, setError] = useState(null); 
    const dataFetchedRef = useRef(false);
    const[showAddEdit, setShowAddEdit] = useState(false);

    
    useEffect(() => {
        if (dataFetchedRef.current) return;
        dataFetchedRef.current = true;

        const DoApiCall = async () => {
            try {
                const response = await api.get(baseURL);
                setdata(response.data);

            } catch (err) {
                setError(err);
            }
        };
        DoApiCall();
    }, []);
    
        if (error) 
        {      

         // console.log(error.message)  ;

          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return <div>Error: {error.message}</div>;
        }
    
        if(!data) return (
          <Layout title="Staff" content="container"><Spinner animation="border" variant="primary" /></Layout>
          );
  
  
        function openAddModal(){           
            setShowAddEdit(true) ;
        }


        return (
            <>
              <Layout title="Subscription" content="container">
                <Breadcrumb className="breadcrumb-arrow my-4">
                  <Breadcrumb.Item><Link to={`/`}>Account</Link></Breadcrumb.Item>
                  <Breadcrumb.Item active>Subscription</Breadcrumb.Item>
                </Breadcrumb>
          
                <Block.Head>
                  <Block.HeadBetween className="align-items-start">
                    <Block.HeadContent>
                      <div className="d-flex flex-column flex-md-row align-items-md-center">
                        <div className="mt-3 mt-md-0 ms-md-3">
                          <h2 className="title mb-1 xtext-primary">Manage Your Subscription</h2>
                          <p className="text-muted">View and update your plan and payment methods.</p>
                        </div>
                      </div>
                    </Block.HeadContent>
                  </Block.HeadBetween>
                </Block.Head>
          
                <Block>
                <Row className="g-4 mb-5">
  {/* Left Column */}
  <Col md="6">
    {/* Company Info */}
    <Card className="shadow-sm border-0">
      <Card.Header className="bg-light border-bottom">
        <h5 className="mb-0 text-dark">Your Company Info</h5>
      </Card.Header>
      <Card.Body>
        <h5 className="xtext-primary">{data.tenants.name}</h5>
        <p className="mb-1">{data.tenants.companyAddress}</p>
        <p className="mb-1"><Icon name="emails" /> {data.tenants.email}</p>
        <p className="mb-0"><Icon name="call" /> {data.tenants.companyPhoneNumber}</p>
      </Card.Body>
    </Card>

    {/* Subscription */}
    <Card className="shadow-sm border-0 mt-4">
      <Card.Header className="bg-light border-bottom">
        <h5 className="mb-0 text-dark">Your Subscription</h5>
      </Card.Header>
      <Card.Body>
        <div className="d-flex justify-content-between">
          <div>
            <h5 className="text-success">{data.subscription.subscriptionName}</h5>
            <div className="text-muted">Max Users: {data.subscription.maxUsers}</div>
          </div>
          <div className="text-end">
            <h5 className="text-dark">£{data.subscription.price}</h5>
            <small className="text-muted">
              {data.subscription.pricePlanType === "monthly" ? "Per Month" : "Per User"}
            </small>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>

  {/* Right Column */}
  <Col md="6">
    {/* Saved Payment Methods */}
    <Card className="shadow-sm border-0">
      <Card.Header className="bg-light border-bottom">
        <h5 className="mb-0 text-dark">Saved Payment Methods</h5>
      </Card.Header>
      <Card.Body>
        <PaymentMethodsList customerId={data.tenants.paymentCustomerId} />
      </Card.Body>
    </Card>

    {/* Add Payment Method */}
    <Card className="shadow-sm border-0 mt-4">
      <Card.Header className="bg-light border-bottom">
        <h5 className="mb-0 text-dark">Add New Payment Method</h5>
      </Card.Header>
      <Card.Body>
        <Elements stripe={stripePromise}>
          <CreatePaymentMethod />
        </Elements>
      </Card.Body>
    </Card>
  </Col>
</Row>


          
                  {/* Optional Email Form Section */}
                  {/* <EmailForm /> */}
          
                  <Timeline />
                </Block>
              </Layout>
            </>
          );
          

//   return (
//     <>
//     <Layout title="Staff" content="container"> 
    
//     <Breadcrumb className="breadcrumb-arrow">
//       <Breadcrumb.Item><Link to={`/`}>Account</Link></Breadcrumb.Item>      
//       <Breadcrumb.Item active>Subscription</Breadcrumb.Item>
//     </Breadcrumb>
   
//     <Block.Head>
//             <Block.HeadBetween className="align-items-start">
//                 <Block.HeadContent>
//                     <div className="d-flex flex-column flex-md-row align-items-md-center">                     
                        
//                         <div className="mt-3 mt-md-0 ms-md-3">
//                             <h3 className="title mb-1">Account Management</h3>                            
//                         </div>
                        
//                     </div>
//                 </Block.HeadContent>              
                 
//             </Block.HeadBetween>

            
//     </Block.Head>

//     <Block>
//         <Row className="g-gs">

//         <Col sm="6" xl="6" xxl="6" key={data.tenants.tenantId}>
//                         <Card className="h-100">
//                             <Card.Body>                              
//                                 <div className="mt-1 mb-4">
//                                     {/* <Link to={`/user-manage/user-profile/${data.tenants.tenantId}`} className="mb-1 h5">{data.tenants.name}</Link> */}
//                                     <div className="mb-1 h5">{data.tenants.name}</div>
//                                     {/* <div className="small">ID : {data.tenants.tenantId}</div> */}
                                    
//                                 </div>
//                                 <div className="mt-1 mb-4">
//                                     <Link to={`/user-manage/user-profile/${data.tenants.tenantId}`} className="mb-1 h5">{data.tenants.companyAddress}</Link>
//                                     <div className="small"><Icon name="emails"></Icon>&nbsp;{data.tenants.email}</div>
//                                     <div className="small"><Icon name="call"></Icon>&nbsp;{data.tenants.companyPhoneNumber}</div>
//                                 </div>                                 
//                             </Card.Body>
//                             {/* <Dropdown className="position-absolute top-0 end-0 p-3">
//                                 <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
//                                     <Icon name="more-v"></Icon>
//                                 </Dropdown.Toggle>
//                                 <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
//                                     <div className="dropdown-content py-1">
//                                         <LinkList className="link-list-hover-bg-primary link-list-md">
//                                             <LinkListItem to={`/company-edit/${data.tenants.tenantId}`}>
//                                                 <Icon name="edit"></Icon><span>Edit</span>
//                                             </LinkListItem>                                           
//                                         </LinkList>
//                                     </div>
//                                 </Dropdown.Menu>
//                             </Dropdown> */}
//                         </Card>
//                     </Col>

//         </Row>
// <br></br>
//         <Row className="g-gs">

//         <Col sm="6" xl="6" xxl="6" key={data.tenants.tenantId}>
//                         <Card className="xh-100">
//                             <Card.Header>Subscription</Card.Header>
//                             <Card.Body>                                                                       
//                                 <Row className="g-gs justify-content-center">
//                                     <Col className="col-5">
//                                         <div className="h5 mb-1">{data.subscription.subscriptionName}</div>                                       
//                                     </Col>
//                                     <Col className="col-5">
//                                         <div className="h5 mb-1">£{data.subscription.price} &nbsp; {(data.subscription.pricePlanType=="monthly"?"Per/Month":"Per/User")}</div>
//                                         <div className="small">Maximum Users : {data.subscription.maxUsers}</div>
//                                     </Col>
//                                 </Row>                                
//                             </Card.Body>
//                             {/* <Dropdown className="position-absolute top-0 end-0 p-3">
//                                 <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
//                                     <Icon name="more-v"></Icon>
//                                 </Dropdown.Toggle>
//                                 <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
//                                     <div className="dropdown-content py-1">
//                                         <LinkList className="link-list-hover-bg-primary link-list-md">
//                                             <LinkListItem to={`/company-edit/${data.tenants.tenantId}`}>
//                                                 <Icon name="edit"></Icon><span>Edit</span>
//                                             </LinkListItem>                                           
//                                         </LinkList>
//                                     </div>
//                                 </Dropdown.Menu>
//                             </Dropdown> */}
//                         </Card>
//                         <Card className="xh-100">
//                             <Card.Header> <h4>Saved Payment Methods</h4></Card.Header>
//                             <Card.Body>                                                                       
//                                 <Row className="g-gs justify-content-center">                                   
//                                     <Col>
//                                         {/* <PaymentMethodsList customerId={"cus_STwLJEWZEf9KRs"} /> */}
//                                         <PaymentMethodsList customerId={data.tenants.paymentCustomerId} />
//                                     </Col>
//                                 </Row>                                
//                             </Card.Body>                           
//                         </Card>
//                         <Card className="xh-100">
//                             <Card.Header>Add New Payment Method</Card.Header>
//                             <Card.Body>                                                                       
//                                 <Row className="g-gs justify-content-center">                                   
//                                     <Col>
//                                         <Elements stripe={stripePromise}>
//                                             <CreatePaymentMethod />
//                                         </Elements>
//                                     </Col>
//                                 </Row>                                
//                             </Card.Body>                           
//                         </Card>
//                     </Col>

//         </Row>
//      </Block>       

  
//     {/* <EmailForm/> */}
    

// <Timeline/>

//     </Layout>


// </>                            


//   )
}


export default Subscription